import LayoutHandler from './LayoutHandler';
import Layout from './dimensions'

export default {
    dimensions: Layout,
    LayoutHandler,
    handler: LayoutHandler
}
